import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import Menu from './menu'
import ErrorSnackbar from './errorSnackbar'
import SuccessSnackbar from './successSnackbar'

const withLayout = (Component) => {
  return () => (
    <div>
      <CssBaseline />
      <Menu>
        <ErrorSnackbar>
          <Component />
        </ErrorSnackbar>
        <SuccessSnackbar />
      </Menu>
    </div>
  )
}

export default withLayout